import { useMatomo } from '@datapunt/matomo-tracker-react';
import cx from 'clsx';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as MapIconSvg } from '@assets/svg/map-icon.svg';

import useTranslation from '@hooks/useTranslation';

import { selectAppPersistMapsVisible, useAppPersistActions } from '@store/useAppStorePersist';

import style from './style.module.scss';

const BtnHeaderMap = () => {
  const { t } = useTranslation();
  const { trackEvent } = useMatomo();

  const { setAppPersistMapsVisible } = useAppPersistActions();

  const mapsVisible = selectAppPersistMapsVisible();

  const toggleVisibleMap = () => {
    if (!mapsVisible)
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

    setAppPersistMapsVisible(!mapsVisible);
    trackEvent({
      category: 'Map Usage',
      action: 'show-map',
      value: !mapsVisible,
    });
  };

  return (
    <div className={cx(style.mapIconWrapper, { [style.mapIconWrapperActive]: mapsVisible })}>
      <MapIconSvg id="tourStep-4" className={style.mapIconSvg} onClick={toggleVisibleMap} />
      <Tooltip anchorSelect="#tourStep-4" content={t(`${mapsVisible ? 'Hide' : 'Show'} map`)} />
    </div>
  );
};

export default BtnHeaderMap;
